export { default } from "./SettingsTemplate"